/* Studio Spice · v1.3 behaviour: article reading bar + contents, back-in-stock product chip */
(function () {
  var d = document, w = window, root = d.documentElement;
  function ready(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }
  var nl = (root.lang || '').indexOf('nl') === 0;

  /* ---------- article ---------- */
  function article() {
    var art = d.querySelector('[data-sb-article]'); if (!art) return;
    var prose = art.querySelector('[data-sb-prose]'), title = art.querySelector('[data-sb-art-title]');
    var bar = art.querySelector('[data-sb-readbar]'), prog = art.querySelector('[data-sb-readbar-p]');
    var hdr = d.querySelector('.sb-hdr-section');
    if (bar) d.body.appendChild(bar);

    /* drop a heading that only repeats the article title; mark the opening paragraph */
    if (prose && title) {
      var norm = function (t) { return (t || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); };
      var first = prose.firstElementChild;
      if (first && /^H[1-3]$/.test(first.tagName) && norm(first.textContent) === norm(title.textContent)) first.remove();
      var p1 = prose.querySelector(':scope > p'); if (p1 && p1.textContent.trim().length > 60) p1.classList.add('sb-lead');
    }
    /* contents list from h2s (desktop only, 3+ headings) */
    var toc = art.querySelector('[data-sb-toc]'), links = [], heads = prose ? Array.prototype.slice.call(prose.querySelectorAll('h2')) : [];
    if (toc && heads.length >= 3) {
      var ol = toc.querySelector('ol');
      heads.forEach(function (h, i) {
        if (!h.id) h.id = 'sb-' + (h.textContent || 'part').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 48) + '-' + i;
        var li = d.createElement('li'), a = d.createElement('a');
        a.href = '#' + h.id; a.textContent = h.textContent.trim();
        a.addEventListener('click', function (e) { e.preventDefault(); h.scrollIntoView({ behavior: 'smooth', block: 'start' }); history.replaceState(null, '', '#' + h.id); });
        li.appendChild(a); ol.appendChild(li); links.push(a);
      });
      toc.hidden = false;
    }

    var ticking = false;
    function update() {
      ticking = false;
      if (!prose) return;
      var r = prose.getBoundingClientRect(), vh = w.innerHeight;
      var p = Math.min(1, Math.max(0, (vh * 0.35 - r.top) / Math.max(1, r.height - vh * 0.35)));
      if (prog) prog.style.transform = 'scaleX(' + p.toFixed(3) + ')';
      var past = title ? title.getBoundingClientRect().bottom < 0 : false;
      var hdrHidden = hdr ? hdr.classList.contains('is-hidden') : true;
      var end = r.bottom < vh * 0.4;
      if (bar) bar.classList.toggle('is-on', past && hdrHidden && !end);
      if (links.length) {
        var cur = 0;
        heads.forEach(function (h, i) { if (h.getBoundingClientRect().top < vh * 0.3) cur = i; });
        links.forEach(function (a, i) { a.classList.toggle('is-on', i === cur); });
      }
    }
    w.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    w.addEventListener('resize', update);
    update();
  }

  /* ---------- back-in-stock popup: show which product ---------- */
  function bis() {
    var P = w.SSBrand && w.SSBrand.product; if (!P || !('MutationObserver' in w)) return;
    function decorate() {
      var dlg = d.querySelector('div[aria-label="POPUP Form"]');
      if (!dlg || !dlg.querySelector('input[name^="opt_in_promotional"]') || dlg.querySelector('.sb-bis')) return;
      var firstRow = dlg.querySelector('[data-testid="form-row"]'); if (!firstRow) return;
      var t = (P.title || '').split(' | '), name = t[0], desc = t[1] || '';
      var box = d.createElement('div'); box.className = 'sb-bis';
      box.innerHTML = (P.image ? '<img src="' + P.image + '" alt="">' : '') + '<div><strong></strong><small style="display:block;font-size:13px;color:#6B5E55;margin-top:2px"></small><span>' + (nl ? 'Tijdelijk uitverkocht' : 'Temporarily sold out') + '</span></div>';
      box.querySelector('strong').textContent = name;
      box.querySelector('small').textContent = desc;
      firstRow.parentNode.insertBefore(box, firstRow.nextSibling);
    }
    var q = false;
    new MutationObserver(function () { if (q) return; q = true; setTimeout(function () { q = false; decorate(); }, 60); }).observe(d.body, { childList: true, subtree: true });
  }

  ready(function () { [article, bis].forEach(function (f) { try { f(); } catch (e) { if (w.console) console.warn('sb13', e); } }); });
})();
